import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { UserSelectableItem } from '../../models/department';
import { Organization } from '../../models/organization';
import { ApiService } from '../../services/api.service';
import { UiNotificationService } from '../../services/ui-notification.service';
import { Reset } from '../../utilities/reset';

@Component({
  selector: 'app-organization-dialog',
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    InputTextModule,
    TabsModule,
    TableModule,
    ButtonModule,
    TranslatePipe,
    DividerModule
  ],
  templateUrl: './organization-dialog.component.html',
  styles: ``,
})
export class OrganizationDialogComponent implements OnInit {
  @Input() isNew = false;
  @Input() messageService!: UiNotificationService;

  // visibilità dialog (bidirezionale)
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  @Input() organization: Organization = Reset.organization();

  // evento finale
  @Output() saved = new EventEmitter<Organization>();

  tabsId: string = '0';

  departments: UserSelectableItem[] = [];

  constructor(private apiService: ApiService, private cdr: ChangeDetectorRef) {
  }

  ngOnChanges() {
    this.tabsId = '0';
    this.departments = [];

    if (!this.isNew && this.organization.organizationId !== 0) {
      this.apiService.getOrganizationDepartments(this.organization.organizationId).subscribe({
        next: (d) => {
          this.departments = structuredClone(d);
          this.cdr.detectChanges();
        },
        error: (err: HttpErrorResponse) => {
          this.departments = [];
          this.messageService.showError(err);
        }
      });
    }
  }

  ngOnInit(): void {
    this.tabsId = '0';
  }

  onClose() {
    this.visible = false;
    this.visibleChange.emit(false);
  }

  onSave(): void {
    if (this.isNew) {
      this.apiService.addOrganization(this.organization).subscribe({
        next: () => {
          this.savedCompleted();
          this.messageService.showSuccess('messages.dataSaved');
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.showError(err);
        }
      });
    } else {
      this.apiService.updateOrganization(this.organization).subscribe({
        next: () => {
          this.savedCompleted();
          this.messageService.showSuccess('messages.dataSaved');
        },
        error: (err: HttpErrorResponse) => {
          this.messageService.showError(err);
        }
      });
    }
  }

  private savedCompleted() {
    this.saved.emit(this.organization);
    this.onClose();
  }
}
